"use strict";

exports.__esModule = true;
exports.getBorderRadiusMobile = exports.getBorderRadius = exports.getBorder = void 0;
const getBorder = ({
  theme
}) => `${theme.orbit.borderWidthCard} ${theme.orbit.borderStyleCard} ${theme.orbit.borderColorCard}`;
exports.getBorder = getBorder;
const getBorderRadius = ({
  theme
}) => `${theme.orbit.borderRadiusNormal}`;
exports.getBorderRadius = getBorderRadius;
const getBorderRadiusMobile = ({
  theme
}) => `${theme.orbit.borderRadiusLarge}`;
exports.getBorderRadiusMobile = getBorderRadiusMobile;